import React, { useState, useRef } from "react";
import arrow from "../assets/imgs/arrow.svg";
import useWindowDimensions from "../hooks/useWindowDimension";
import "../styles/whitecard.css";

const Footer = () => {

  const whiteCard = useRef(null);
  const { width, height } = useWindowDimensions();

  const [popup, setPop] = useState(false);
  const handleClickOpen = () => {
    setPop(!popup);
    setTimeout(() => {
      whiteCard.current.scrollIntoView();
      window.scrollTo({ top: height / 4, left: 0, behavior: 'smooth' });
    }, 100);
  };
  const closePopup = () => {
    setPop(false);
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-left">
          <div className="footer-links">
            <ul>
              <li className="list-heading">About</li>
              <li className="list-item"><a href="https://docs.voxlink.io/"
                target="_blank">What is Voxlink</a></li>
              <li className="list-item"><a href="https://discord.gg/ZhXExzbB"
                target="_blank">Partnerships</a></li>
              <li className="list-item"><a href="https://dune.com/home"
                target="_blank">Dune</a></li>
              <li className="list-item"><a href="https://etherscan.io/"
                target="_blank">Etherscan</a></li>
            </ul>
            <ul>
              <li className="list-heading">News</li>
              <li className="list-item"><a href="https://medium.com/@voxlink.io"
                target="_blank">Blog</a></li>
              <li className="list-item"><a href="https://medium.com/@voxlink.io"
                target="_blank">Medium</a></li>
              <li className="list-item"><a href="https://www.linkedin.com/company/voxlink-eth/"
                target="_blank">LinkedIn</a></li>
            </ul>
            <ul>
              <li className="list-heading">Our Team</li>
              <li className="list-item"><a href="https://www.cryptojobs.com/companies/voxlink"
                target="_blank">Careers</a></li>
              <li className="list-item"><a href="https://www.cryptojobs.com/companies/voxlink"
                target="_blank">Board</a></li>
            </ul>
            <ul>
              <li className="list-heading">FAQ</li>
              <li className="list-item"><a href="https://medium.com/@voxlink.io"
                target="_blank">Medium</a></li>
              <li className="list-item">Notion</li>
              <li className="list-item"><a href="https://docs.voxlink.io/"
                target="_blank">Terms of Use</a></li>
              <li className="list-item"><a href="https://docs.voxlink.io/"
                target="_blank">Privacy Policy</a></li>
            </ul>
            <ul>
              <li className="list-heading">Contact Us</li>
              <li className="list-item"><a href="https://twitter.com/_voxlink"
                target="_blank">Twitter</a></li>
              <li className="list-item"><a href="https://discord.gg/nn6yp63F"
                target="_blank">Discord</a></li>
              <li className="list-item"><a href="https://t.me/voxlinkio"
                target="_blank">Telegram</a></li>
              <li className="list-item"><a href="https://discord.gg/FR82CJ3T"
                target="_blank">Open Ticket</a></li>
            </ul>
          </div>
          <div className="footer-form">
            <label className="list-heading">Sign up for our newsletter</label>
            <div className="footer-form-input">
              <input type="text" placeholder="E-mail" />
              <button>Sign up</button>
            </div>
          </div>
        </div>
        <div className="footer-create-btn" onClick={handleClickOpen}>
          <img src={arrow} alt="arrow" />
          How do I proceed?
        </div>
      </footer>

      {/* WhiteCard part  */}

      {popup ? (
        <div ref={whiteCard} className="white_container">
          <div className="close_box">
            <div className="close_h3">
              <h3 onClick={closePopup}>   ⓧ   </h3>
            </div>
            <div className="heading_h1">
              <h1>A quick walkthrough... </h1>
            </div>
          </div>

          <div className="text_column">
            <div className="text_h4">
              <h4 className="">
                Step 1: Write down your burner wallet address and your main wallet address in their respective fields.
              </h4>
              <p>
                Once you've created your burner wallet, type your burner wallet address in the field above. This address will be used to sign your transactions on behalf of your main wallet, containing all of your assets.
              </p>
            </div>
            <div className="text_h4">
              <h4>
                Step 2: Sign the transactions from both your main and burner wallets.
              </h4>
              <p>
                Sign both your burner and main wallet's transactions in order to validate the connection. This will allow any ERC721 or ERC20 token/NFT to be sent to your main wallet every time you sign a transaction with your burner.
              </p>
            </div>
            <div className="text_h4">
              <h4>
                Step 3: Your assets are now safe, and you've created your Voxlink.
              </h4>
              <p>
                Now that your burner wallet has been assigned as your main wallet's protective shield, you can mint safely and securely knowing that your assets will be transferred seemlessly to your main wallet. Just make sure to always sign transactions through your burner wallet.
              </p>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Footer;
